const SSO_ATTEMPT_KEY = 'art#cb#ssoAttempt';

interface SsoAttempt {
  email: string;
  provider: string;
}

// Cognito's SAML redirect drops the browser back on /login with only an `error`/`error_description`
// query string — the email/provider chosen in Step 1/2 is lost on reload. Stash it right before the
// redirect so the SSO step can be re-rendered with its error message on return.
export const stashSsoAttempt = ({ email, provider }: SsoAttempt): void => {
  sessionStorage.setItem(SSO_ATTEMPT_KEY, JSON.stringify({ email, provider }));
};

export const consumeSsoAttempt = (): SsoAttempt | null => {
  const raw = sessionStorage.getItem(SSO_ATTEMPT_KEY);
  sessionStorage.removeItem(SSO_ATTEMPT_KEY);

  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    return parsed?.email && parsed?.provider ? parsed : null;
  } catch {
    return null;
  }
};
